export class Carousel{
    public name: string;
    public imagePath: string
    constructor(name:string,imagePath:string){
        this.name = name;
        this.imagePath = imagePath;
    }
}